import React from "react";

interface CardCoverProps {
  children?: React.ReactNode;
}

export const CardCover = ({ children }: CardCoverProps) => {
  return <div className="flex items-center justify-center">{children}</div>;
};
